import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router'

const ItemStyles = `
  cursor: pointer;
  display: block;
  padding: 10px 20px;
  white-space: nowrap;
  text-align: left;
  color: inherit;
  &:hover {
    background: #f5f5f5;
  }
`

const StyledHref = styled.a`
  ${ItemStyles};
`
const StyledDiv = StyledHref.withComponent('div')
const DisabledWrapper = StyledDiv.extend`
  cursor: not-allowed;
  opacity: 0.4;
`

const MenuDivider = styled.li`
  height: 1px;
  margin: 9px 20px;
  overflow: hidden;
  background: #e5e5e5;
`

const StructuralLink = ({ className, children, ...rest }) => (
  <Link className={className} {...rest}>
    {children}
  </Link>
)
StructuralLink.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

const StyledLink = styled(StructuralLink)`
  ${ItemStyles};
`

const MenuItem = ({ children, disabled, divider, onClick, onSelect, url }) => {
  const handleClick = (event) => {
    if (onClick) {
      onClick(event)
    }
    if (onSelect) {
      onSelect(event)
    }
  }

  const handleProps = {
    onClick: handleClick,
  }

  if (divider) {
    return <MenuDivider />
  }

  if (disabled) {
    return <DisabledWrapper>{children}</DisabledWrapper>
  }

  if (url) {
    // if url begins with 'http' assume it is an external link
    if (url.slice(0, 4) === 'http') {
      return (
        <StyledHref
          href={url}
          rel="noopener noreferrer"
          target="_blank"
          onClick={handleClick}
        >
          {children}
        </StyledHref>
      )
    }
    return (
      <StyledLink to={url} onClick={handleClick}>
        {children}
      </StyledLink>
    )
  }
  return <StyledDiv {...handleProps}>{children}</StyledDiv>
}

MenuItem.displayName = 'MenuItem'
MenuItem.propTypes = {
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  children: PropTypes.node,
  url: PropTypes.string,
}

MenuItem.defaultProps = {
  disabled: false,
  divider: false,
  onClick: () => null,
  onSelect: () => null,
  children: null,
  url: '',
}

export default MenuItem
